$(document).ready(
    function () {

        let p = $("body").attr("p");
        let a = $("body").attr("a");
        if (p === 'organizer_booking_reservation' && a === 'list') {

            let locationId = $("body").attr("event_id");
            let todayDate = $('#calendar').attr('data-date');
            let bookingSummary = [];
            let bookingSummaryTotal;
            let dataGraph;
            let disabledDates = [];
            let calendarDate = null;

            function getBookingSummaryWeekAndMonth() {
                return; // Not used
                let bookingTotal = 0;
                let seatsTotal = 0;
                $.each(bookingSummary, (index, item) => {
                    let appendBookingSummary = "(" + item.number_of_bookings + "/" + item.number_of_seats + ")";
                    $("tr.fc-timeline-header-row th.fc-timeline-slot").each(function () {
                        if ($(this).data("date") === index && $(this).children("p.booking-summary").length) {
                            $(this).children("p.booking-summary").text(appendBookingSummary);
                            bookingTotal += item.number_of_bookings;
                            seatsTotal += item.number_of_seats;
                        }
                    });
                });
                getBookingSummaryTotal(bookingTotal, seatsTotal);
            }

            function getBookingSummaryDay() {
                return; // Not used
                if(bookingSummary !== undefined && bookingSummary !== null) {
                    let bookingTotalDay = 0;
                    let seatsTotalDay = 0;
                    let dateToday = new Date(todayDate);
                    let slotDateString = $("tr.fc-timeline-header-row th.fc-timeline-slot").first().data("date");
                    let slotDate = new Date(slotDateString);
                    if (slotDate.getTime() >= dateToday.getTime()) {
                        slotDateString = slotDateString.slice(0, 10);
                        if (bookingSummary[slotDateString] !== undefined && bookingSummary[slotDateString] !== null) {
                            bookingTotalDay = bookingSummary[slotDateString].number_of_bookings;
                            seatsTotalDay = bookingSummary[slotDateString].number_of_seats;
                        }
                        getBookingSummaryTotal(bookingTotalDay, seatsTotalDay);
                    }
                }
            }

            function getBookingSummaryTotal(bookingTotal, seatsTotal) {
                let appendBookingSummaryTotal = bookingSummaryTotal;
                appendBookingSummaryTotal = appendBookingSummaryTotal.replace("NUM_BOOKINGS", bookingTotal);
                appendBookingSummaryTotal = appendBookingSummaryTotal.replace("NUM_SEATS", seatsTotal);

                let appendBookingSummaryTotalWrapper = "<span class='booking-summary-total'></span>";
                if (!$("div.fc-header-toolbar div.fc-toolbar-chunk").first().children("span.booking-summary-total").length) {
                    $("div.fc-header-toolbar div.fc-toolbar-chunk").first().append(appendBookingSummaryTotalWrapper);
                }
                $("span.booking-summary-total").empty();

                $("div.fc-header-toolbar div.fc-toolbar-chunk").first().children("span.booking-summary-total").text(appendBookingSummaryTotal);
            }

            function getBookingReservations(events, update = false) {
                let lastUpdatedDate = $('#calendar').attr('data-last-updated-date');

                let employer_token = null;
                if ($("body").attr("employer_token") != undefined) {
                    employer_token = $("body").attr("employer_token");
                }

                if (update === false && $('#booking-bar-graph').length) {
                    //$('#booking-bar-graph').empty();
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/get_booking_reservations",
                    data: {
                        location_id: locationId,
                        reservation_date: lastUpdatedDate,
                        is_update: update,
                        employer_token: employer_token,
                        calendar_date: calendarDate,
                        period_type: (calendar !== undefined) ? calendar.view.type : 'day',
                        active_start: (calendar !== undefined) ? formatDate(calendar.view.activeStart) : null,
                        active_end: (calendar !== undefined) ? formatDate(calendar.view.activeEnd) : null
                    }
                })
                    .done(function (data) {
                        if (data.last_updated_booking_reservations_date !== undefined && data.last_updated_booking_reservations_date !== null) {
                            $('#calendar').attr('data-last-updated-date', data.last_updated_booking_reservations_date);
                        }
                        if (data.booking_reservations !== undefined && data.booking_reservations !== null) {
                            if (!update) {
                                calendar.removeAllEvents();
                            }
                            events(JSON.parse(data.booking_reservations));
                        }
                        if (data.booking_summary_total !== undefined
                            && data.booking_summary_total !== null
                            && bookingSummaryTotal === undefined
                        ) {
                            bookingSummaryTotal = data.booking_summary_total;
                        }
                        if (data.booking_summary !== undefined && data.booking_summary !== null) {
                            bookingSummary = JSON.parse(data.booking_summary);
                            if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                                getBookingSummaryWeekAndMonth();
                            }
                            if (calendar.view.type === 'resourceTimeline') {
                                getBookingSummaryDay();
                            }
                        }
                        if (data.graph !== undefined && data.graph !== null) {
                            dataGraph = data.graph;
                            tableGraph();
                        }
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function getBookingTables(resources) {

                let employer_token = null;
                if ($("body").attr("employer_token") != undefined) {
                    employer_token = $("body").attr("employer_token");
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/get_booking_tables",
                    data: {
                        location_id: locationId,
                        employer_token: employer_token
                    }
                })
                    .done(function (data) {
                        resources(JSON.parse(data));
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function getOpeningHours(date, hours) {

                let employer_token = null;
                if ($("body").attr("employer_token") != undefined) {
                    employer_token = $("body").attr("employer_token");
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/get_opening_time_for_date",
                    data: {
                        location_id: locationId,
                        reservation_date: date,
                        employer_token: employer_token
                    }
                })
                    .done(function (data) {
                        hours(JSON.parse(data));
                        $("p.booking-summary").remove();
                        /*let appendBookingSummaryTotalWrapper = "<span class='booking-summary-total'></span>";
                        if (!$("div.fc-header-toolbar div.fc-toolbar-chunk").first().children("span.booking-summary-total").length) {
                            $("div.fc-header-toolbar div.fc-toolbar-chunk").first().append(appendBookingSummaryTotalWrapper);
                        }
                        $("span.booking-summary-total").empty();*/
                        if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                            let appendBookingSummaryWrapper = "<p class='booking-summary'>(0/0)</p>";
                            let dateToday = new Date(todayDate);
                            $("tr.fc-timeline-header-row th.fc-timeline-slot").each(function () {
                                let slotDate = new Date($(this).data("date"));
                                if (Number(slotDate.getTime()) < Number(dateToday.getTime())){
                                    return;
                                }
                                if (!$(this).children("p.booking-summary").length) {
                                    $(this).append(appendBookingSummaryWrapper);
                                }
                            });
                            getBookingSummaryWeekAndMonth();
                        }
                        if (calendar.view.type === 'resourceTimeline') {
                            getBookingSummaryDay();
                        }
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function getBookingBlockingList(type, startDate, endDate, bookingBlockingList) {
                return;
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_blocking/list",
                    data: {
                        location_id: locationId,
                        type: type,
                        start_date: startDate,
                        end_date: endDate,
                    }
                })
                    .done(function (data) {
                        bookingBlockingList(data);
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function updateBookingReservation(event, table = null, response) {
                let tableId = null;
                if (table !== null) {
                    tableId = table.id;
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/update",
                    data: {
                        location_id: locationId,
                        booking_reservation_id: event.id,
                        reservation_date: event.start.toISOString(),
                        reservation_date_end: event.end.toISOString(),
                        table_id: tableId,
                        calendar_date: calendarDate,
                        period_type: (calendar !== undefined) ? calendar.view.type : 'day',
                        active_start: (calendar !== undefined) ? formatDate(calendar.view.activeStart) : null,
                        active_end: (calendar !== undefined) ? formatDate(calendar.view.activeEnd) : null,
                        calendar_drag_and_drop: true
                    }
                })
                    .done(function (data) {
                        if (data.booking_reservations !== undefined && data.booking_reservations !== null) {
                            /*let event = JSON.parse(data.booking_reservations);
                            let calendarEvent = calendar.getEventById(event[0].id);
                            calendarEvent.remove();
                            //calendar.addEventSource(event);
                            /!*lastTimestamp = null;
                            calendar.refetchEvents();*!/
                            $(".popover").remove();
                            dataGraph = data.graph;
                            tableGraph();*/
                            $(".popover").remove();
                            calendar.refetchEvents();
                        }
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                        response(data.responseJSON);
                    })
            }


            $(document).on("click", "#booking-blocking-from-event-modal-button", function (e) {
                e.preventDefault();
                $(this).blur();
                $('#modal-booking-reservation').modal('hide');
                setTimeout(function () {
                    $('#modal-booking-reservation').remove();
                }, 500);

                getBookingBlockingModal($(this).data('start-date'), $(this).data('end-date'), $(this).data('type'), $(this).data('table-id'), function (modal) {
                    $('#content').append(modal);
                    if ($('#modal-booking-blocking').length) {
                        $('#modal-booking-blocking').modal('show');
                    }
                    if ($('#modal-booking-unblocking').length) {
                        $('#modal-booking-unblocking').modal('show');
                    }
                });
            });

            function removeBlockedTimeslots(timeslotArray, table_id) {
                let tableBlockedTimeslots = document.querySelectorAll(`.slot-blocked-wrapper[data-table-id="${table_id}"]`);
                timeslotArray.forEach(timeslot => {
                    Array.from(tableBlockedTimeslots).forEach(function (slot) {
                        let blockedTimeslotDate = new Date($(slot).data('timeslot'));
                        let activatedTimeslotDate = new Date(timeslot);
                        if (blockedTimeslotDate.getTime() === activatedTimeslotDate.getTime()) {
                            $(slot).remove();
                        }
                    });
                });
            }

            function markBlockedTimeslots(timeslotArray, table_id) {
                let resourceTableRows = $('.fc-scroller-harness .fc-scroller .fc-timeline-body .fc-scrollgrid-sync-table .fc-timeline-lane.fc-resource');
                let numberOfResourceRows = 0;
                let indexOfResourceRows = 0;
                resourceTableRows.each(function (index) {
                    if ($(this).attr('data-resource-id') === table_id) {
                        indexOfResourceRows = index;
                        return false;
                    }
                    numberOfResourceRows++;
                });

                let indexOfResources = [];
                $('.fc-scroller-harness .fc-datagrid-body.fc-scrollgrid-sync-table .fc-resource').each(function(index){
                    if ($(this).attr('data-resource-id')?.startsWith('booking-area-id')) {
                        indexOfResources.push(index);
                    }
                });

                timeslotArray.sort(function(a, b) {
                    return a.list_order - b.list_order;
                });

                timeslotArray.forEach(timeslot => {
                    let timeSlotDate = new Date(timeslot);
                    let resourceTimeSlots = $("div.fc-timeline-body div.fc-timeline-slots td.fc-timeline-slot");
                    let slotWidth = $("div.fc-timeline-slots td.fc-timeline-slot.fc-timeline-slot-lane").first().outerWidth();
                    let numberOfSlots = 0;
                    resourceTimeSlots.each(function () {
                        let slotDate = new Date($(this).attr('data-date'));
                        if (slotDate.getTime() === timeSlotDate.getTime()) {
                            let countBeforeIndex = indexOfResources.filter(function(index) {
                                return index < numberOfResourceRows;
                            }).length;
                            let left = numberOfSlots * slotWidth + 2;
                            let top = ((numberOfResourceRows - countBeforeIndex) * 39) + (countBeforeIndex * 20);
                            let timelineSlotMarkerWrapper = $("<div>");
                            timelineSlotMarkerWrapper.css('left', left);
                            //timelineSlotMarkerWrapper.css('top', top);
                            timelineSlotMarkerWrapper.css('top', 0);
                            timelineSlotMarkerWrapper.addClass('slot-blocked-wrapper');
                            timelineSlotMarkerWrapper.attr('data-table-id', table_id);
                            timelineSlotMarkerWrapper.attr('data-timeslot', timeslot);
                            let timelineSlotMarker = $("<div>");
                            timelineSlotMarker.addClass('slot-blocked');
                            timelineSlotMarkerWrapper.append(timelineSlotMarker);
                            let resourceTableRow = $('.fc-scroller-harness .fc-scroller .fc-timeline-body .fc-scrollgrid-sync-table .fc-timeline-lane.fc-resource').eq(indexOfResourceRows);
                            resourceTableRow.append(timelineSlotMarkerWrapper);
                        }
                        numberOfSlots++;
                    });
                });
            }

            $(document).on("click", "#booking-blocking-form-cancel-button", function (e) {
                e.preventDefault();
                $(this).blur();
                $('#modal-booking-blocking').modal('hide');
                setTimeout(function () {
                    $('#modal-booking-blocking').remove();
                }, 500);
            });

            $(document).on("click", "#booking-unblocking-form-cancel-button", function (e) {
                e.preventDefault();
                $(this).blur();
                $('#modal-booking-unblocking').modal('hide');
                setTimeout(function () {
                    $('#modal-booking-unblocking').remove();
                }, 500);
            });

            $(document).on("submit", "#booking-blocking-form", function (e) {
                e.preventDefault();
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_blocking/new",
                    data: {
                        serialized_post: $(this).serialize()
                    }
                })
                    .done(function (data) {

                        $('#booking-blocking-form-submit-button').blur();
                        $('#modal-booking-blocking').modal('hide');
                        setTimeout(function () {
                            $('#modal-booking-blocking').remove();
                        }, 500);

                        /*if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                            let startDate = calendar.view.activeStart;
                            let endDate = calendar.view.activeEnd;
                            let currentDate = new Date(startDate);
                            while (currentDate < endDate) {
                                let formatedCurrentDate = formatDate(currentDate);
                                if (data.disabled_dates.includes(formatedCurrentDate)) {
                                    if (data.table_id !== undefined && data.table_id !== null) {
                                        let table_id = data.table_id;
                                        let tableCells = document.querySelectorAll(`.fc-resource[data-resource-id="${table_id}"]`);
                                        tableCells.forEach(cell => {
                                            cell.classList.add('blocked');
                                        });
                                    } else {
                                        let dayCells = document.querySelectorAll(`.fc-day[data-date="${formatedCurrentDate}"]`);
                                        dayCells.forEach(cell => {
                                            cell.classList.add('blocked');
                                        });
                                    }
                                }
                                currentDate.setDate(currentDate.getDate() + 1);
                            }
                        }
                        if (calendar.view.type === 'resourceTimeline') {
                            if (data.disabled_dates.length !== 0) {
                                let tableCells = document.querySelectorAll(`.fc-resource[data-resource-id="${data.table_id}"]`);
                                tableCells.forEach(cell => {
                                    cell.classList.add('blocked');
                                });
                            }
                            if (data.disabled_timeslots.length !== 0 && data.table_id !== undefined && data.table_id !== null) {
                                markBlockedTimeslots(data.disabled_timeslots, data.table_id);
                            }
                            if (data.disabled_timeslots.length !== 0 && (data.table_id === undefined || data.table_id === null)) {
                                $(".fc-datagrid-cell.fc-resource").each(function () {
                                    if ($(this).attr('data-resource-id')?.startsWith('booking-area-id')) {
                                        return true;
                                    }
                                    markBlockedTimeslots(data.disabled_timeslots, $(this).attr('data-resource-id'));
                                });
                            }
                        }*/

                        calendar.refetchEvents();

                        if (data.table_has_booking_reservation !== undefined && data.table_has_booking_reservation !== null) {
                            setTimeout(function () {
                                alert(data.table_has_booking_reservation);
                            }, 500);
                        }

                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                        if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                            prependAlert('#booking-blocking-form-button-wrapper', data.responseJSON.error_message, 'danger', null, '#booking-blocking-form');
                        }
                    })
            });

            $(document).on("submit", "#booking-unblocking-form", function (e) {
                e.preventDefault();
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_blocking/delete",
                    data: {
                        serialized_post: $(this).serialize()
                    }
                })
                    .done(function (data) {
                        calendar.refetchEvents();

                        $('#booking-unblocking-form-submit-button').blur();
                        $('#modal-booking-unblocking').modal('hide');
                        setTimeout(function () {
                            $('#modal-booking-unblocking').remove();
                        }, 500);

                        /*if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                            let startDate = calendar.view.activeStart;
                            let endDate = calendar.view.activeEnd;
                            let currentDate = new Date(startDate);
                            while (currentDate < endDate) {
                                let formatedCurrentDate = formatDate(currentDate);
                                if (data.activated_dates.includes(formatedCurrentDate)) {
                                    if (data.table_id !== undefined && data.table_id !== null) {
                                        let tableCells = document.querySelectorAll(`.fc-resource[data-resource-id="${data.table_id}"]`);
                                        tableCells.forEach(cell => {
                                            cell.classList.remove('blocked');
                                        });
                                    } else {
                                        let dayCells = document.querySelectorAll(`.fc-day[data-date="${formatedCurrentDate}"]`);
                                        dayCells.forEach(cell => {
                                            cell.classList.remove('blocked');
                                        });
                                    }
                                }
                                currentDate.setDate(currentDate.getDate() + 1);
                            }
                        }
                        if (calendar.view.type === 'resourceTimeline') {
                            let tableCells = document.querySelectorAll(`.fc-resource[data-resource-id="${data.table_id}"]`);
                            tableCells.forEach(cell => {
                                cell.classList.remove('blocked');
                            });
                            if (data.activated_timeslots.length !== 0 && data.table_id !== undefined && data.table_id !== null) {
                                removeBlockedTimeslots(data.activated_timeslots, data.table_id)
                            }
                            if (data.activated_timeslots.length !== 0 && (data.table_id === undefined || data.table_id === null)) {
                                $(".fc-datagrid-cell.fc-resource").each(function () {
                                    if ($(this).attr('data-resource-id')?.startsWith('booking-area-id')) {
                                        return true;
                                    }
                                    removeBlockedTimeslots(data.activated_timeslots, $(this).attr('data-resource-id'));
                                });
                            }
                        }*/
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                        if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                            prependAlert('#booking-unblocking-form-button-wrapper', data.responseJSON.error_message, 'danger', null, '#booking-unblocking-form');
                        }
                    })
            });

            function getBookingBlockingModal(startDate, endDate, type, tableId = null, modal) {
                if ($('#modal-booking-blocking').length) {
                    $('#modal-booking-blocking').remove();
                }
                if ($('#modal-booking-unblocking').length) {
                    $('#modal-booking-unblocking').remove();
                }
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_blocking/get_modal",
                    data: {
                        location_id: locationId,
                        start_date: startDate,
                        end_date: endDate,
                        type: type,
                        table_id: tableId
                    }
                })
                    .done(function (data) {
                        modal(data.html);
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function getBookingReservationModal(info, modal) {
                if ($('#modal-booking-reservation').length) {
                    $('#modal-booking-reservation').remove();
                }
                let bookingReservationId = null;
                let reservationDate = null;
                let reservationDateEnd = null;
                let tableId = null;
                if (info.event !== undefined && info.event !== null) {
                    bookingReservationId = info.event.id;
                }
                if (info.startStr !== undefined && info.startStr !== null) {
                    reservationDate = info.startStr;
                }
                if (info.endStr !== undefined && info.endStr !== null) {
                    reservationDateEnd = info.endStr;
                }
                if (info.resource !== undefined && info.resource !== null) {
                    tableId = info.resource.id;
                }

                let employer_token = null;
                if ($("body").attr("employer_token") != undefined) {
                    employer_token = $("body").attr("employer_token");
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/get_modal",
                    data: {
                        location_id: locationId,
                        booking_reservation_id: bookingReservationId,
                        reservation_date: reservationDate,
                        reservation_date_end: reservationDateEnd,
                        table_id: tableId,
                        employer_token: employer_token
                    }
                })
                    .done(function (data) {
                        modal(data.html);
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            $(document).on("click", "#delete-booking-reservation", function () {

                let locationId = $(this).data("location-id");
                let reservationDate = $(this).data("reservation-date");
                let bookingReservationId = $(this).data("booking-reservation-id");
                let confirmMessage = $(this).data("confirm-message");

                if (!confirm(confirmMessage)) {
                    return false;
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/delete",
                    data: {
                        location_id: locationId,
                        reservation_date: reservationDate,
                        booking_reservation_id: bookingReservationId,
                        calendar_date: calendarDate,
                        period_type: (calendar !== undefined) ? calendar.view.type : 'day',
                        active_start: (calendar !== undefined) ? formatDate(calendar.view.activeStart) : null,
                        active_end: (calendar !== undefined) ? formatDate(calendar.view.activeEnd) : null
                    }
                })
                    .done(function (data) {

                        if (data.booking_summary !== undefined && data.booking_summary !== null) {
                            bookingSummary = JSON.parse(data.booking_summary);
                            if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                                getBookingSummaryWeekAndMonth();
                            }
                            if (calendar.view.type === 'resourceTimeline') {
                                getBookingSummaryDay();
                            }
                            popupAlert();
                            let calendarEvent = calendar.getEventById(bookingReservationId);
                            calendarEvent.remove();
                            $('#modal-booking-reservation').modal('hide');
                            setTimeout(function () {
                                $('#modal-booking-reservation').remove();
                            }, 2000);
                            dataGraph = data.graph;
                            tableGraph();
                        }

                    })
                    .fail(function (data) {

                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }

                        if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                            prependAlert('#booking-reservation-form-button-wrapper', data.responseJSON.error_message, 'danger', null, '#booking-reservation-from-admin-form');
                        }

                    });
                    return false;
            });


            $(document).on("submit", "#booking-reservation-from-admin-form", function (e) {
                e.preventDefault();
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/update",
                    data: {
                        serialized_post: $(this).serialize(),
                        period_type: (calendar !== undefined) ? calendar.view.type : 'day',
                        active_start: (calendar !== undefined) ? formatDate(calendar.view.activeStart) : null,
                        active_end: (calendar !== undefined) ? formatDate(calendar.view.activeEnd) : null
                    }
                })
                    .done(function (data) {
                        if (data.booking_reservations !== undefined && data.booking_reservations !== null && data.new_event !== undefined && data.new_event !== null) {
                            let lastCheckedForNewEvents = new Date($('#calendar').attr('data-last-updated-date'));
                            let lastEventDate = new Date(data.last_updated_booking_reservations_date);
                            if (lastCheckedForNewEvents < lastEventDate) {
                                $('#calendar').attr('data-last-updated-date', data.last_updated_booking_reservations_date);
                                let event = JSON.parse(data.booking_reservations);
                                //calendar.addEventSource(event);
                                lastTimestamp = null;
                                calendar.refetchEvents();
                            }
                        }
                        if (data.booking_reservations !== undefined && data.booking_reservations !== null && data.update_event !== undefined && data.update_event !== null) {
                            let event = JSON.parse(data.booking_reservations);
                            let calendarEvent = calendar.getEventById(event[0].id);
                            calendarEvent.remove();
                            //calendar.addEventSource(event);
                            lastTimestamp = null;
                            calendar.refetchEvents();
                        }
                        if (data.booking_summary !== undefined && data.booking_summary !== null) {
                            bookingSummary = JSON.parse(data.booking_summary);
                            if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                                getBookingSummaryWeekAndMonth();
                            }
                            if (calendar.view.type === 'resourceTimeline') {
                                getBookingSummaryDay();
                            }
                        }
                        $('#modal-booking-reservation').modal('hide');
                        setTimeout(function () {
                            $('#modal-booking-reservation').remove();
                        }, 2000);
                        if (data.overbooked !== undefined && data.overbooked !== null) {
                            setTimeout(function () {
                                alert(data.overbooked);
                            }, 1000);
                        }
                        if (data.underbooked !== undefined && data.underbooked !== null) {
                            setTimeout(function () {
                                alert(data.underbooked);
                            }, 1000);
                        }
                        if (data.booking_blocking !== undefined && data.booking_blocking !== null) {
                            setTimeout(function () {
                                alert(data.booking_blocking);
                            }, 1000);
                        }
                        dataGraph = data.graph;
                        tableGraph();
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                        if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                            prependAlert('#booking-reservation-form-button-wrapper', data.responseJSON.error_message, 'danger', null, '#booking-reservation-from-admin-form');
                        }
                    })
                return false;
            });

            function formatDate(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }

            let lastTimestamp = null;      // null → full fetch
            let lastFetchInfo = null;      // { start: Date, end: Date } of the previous request
            let lastViewInfo  = null;

            let calendarEl = document.getElementById('calendar');
            let calendar = new FullCalendar.Calendar(calendarEl, {
                schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                themeSystem: 'standard',
                initialView: 'resourceTimeline',
                initialDate: todayDate,
                editable: true,
                height: 'auto',
                timeZone: 'Europe/Oslo',
                weekNumberCalculation: 'ISO',
                headerToolbar: {
                    left: 'resourceTimelineMonth,resourceTimelineWeek,resourceTimeline',
                    center: 'title',
                    right: 'prev,next today'
                },
                buttonText: {
                    today: 'i dag',
                    month: 'måned',
                    week: 'uke',
                    day: 'dag',
                    list: 'list',
                    resourceTimeline: "dag"
                },
                resourceAreaHeaderContent: 'Bord',
                views: {
                    resourceTimeline: {
                        type: 'resourceTimeline',
                        slotDuration: '00:15:00'
                    },
                    resourceTimelineWeek: {
                        type: 'resourceTimelineWeek',
                        duration: { weeks: 1 },
                        slotDuration: {days: 1},
                        slotLabelFormat:{
                            weekday: 'long', day: 'numeric'
                        }
                    },
                    resourceTimelineMonth: {
                        type: 'resourceTimelineMonth',
                        duration: { month: 1 },
                        slotDuration: {days: 1},
                        slotLabelFormat:{
                            day: '2-digit'
                        }
                    }
                },
                eventDidMount: function (eventInfo) {
                    if (eventInfo.event.extendedProps.popover !== undefined) {
                        $(eventInfo.el).popover({
                            placement: 'right',
                            trigger: 'hover',
                            html: true,
                            content: eventInfo.event.extendedProps.popover,
                            container: 'body'
                        });
                    }
                },
                resources: function (fetchInfo, successCallback) {
                    getBookingTables(function (resources) {
                        successCallback(resources);
                    });
                },
                resourceOrder: 'list_order',
                resourcesSet: function () {
                    $('.blocking-reservation-table-button').remove();
                    $(".fc-datagrid-cell.fc-resource").each(function () {
                        if ($(this).attr('data-resource-id')?.startsWith('booking-area-id')) {
                            return true;
                        }
                        let displayBlock = ($('#blocking-toggle').hasClass('fc-button-active'))?'':'d-none ';
                        $(this).find('.fc-datagrid-cell-main').after('<span class="' + displayBlock + 'blocking-btn blocking-reservation-table-button" data-resource-id="' + $(this).attr('data-resource-id') + '"><i class="material-icons">block</i></span>');
                    });
                },
                /*eventSources: function (eventInfo, successCallback) {
                    calendarDate = eventInfo.startStr;
                    getBookingReservations(function (events) {
                        successCallback(events);
                    });
                },*/
                events: function(fetchInfo, successCallback, failureCallback) {
                    // fetchInfo.start and fetchInfo.end are the current view's start and end dates
                    let from = formatDate(fetchInfo.start);
                    let to = formatDate(fetchInfo.end);

                    /* ---- detect a change of the visible range ---- */
                    if (lastFetchInfo &&
                        (lastFetchInfo.start.getTime() !== fetchInfo.start.getTime() ||
                            lastFetchInfo.end.getTime()   !== fetchInfo.end.getTime())) {
                        lastTimestamp = null;               // force a **full** fetch
                    }

                    /* remember the range we are fetching now */
                    lastFetchInfo = { start: fetchInfo.start, end: fetchInfo.end };

                    let employer_token = null;
                    if ($("body").attr("employer_token") !== undefined) {
                        employer_token = $("body").attr("employer_token");
                    }

                    if (lastTimestamp === null && $('#booking-bar-graph').length) {
                        //$('#booking-bar-graph').empty();
                    }
                    let isUpdate = (lastTimestamp !== null);
                    let viewType = 'resourceTimeline';
                    if(calendar !== undefined) {
                        viewType = calendar.view.type;
                    }

                    $.ajax({
                        url: "/ajax/organizer_booking_reservation/get_booking_reservations",
                        type: 'POST',
                        data: {
                            location_id: locationId,
                            reservation_date: lastTimestamp,
                            is_update: isUpdate,
                            employer_token: employer_token,
                            calendar_date: calendarDate,
                            period_type: viewType,
                            active_start: from,
                            active_end: to
                        },
                        success: function(data) {
                            let thisIsFirstRunForThisView = lastTimestamp !== null;
                            if (data.last_updated_booking_reservations_date !== undefined && data.last_updated_booking_reservations_date !== null) {
                                $('#calendar').attr('data-last-updated-date', data.last_updated_booking_reservations_date);
                                lastTimestamp = data.last_updated_booking_reservations_date;
                            }
                            if (data.booking_reservations !== undefined && data.booking_reservations !== null) {
                                /*if (!update) {
                                    calendar.removeAllEvents();
                                }*/
                                successCallback(JSON.parse(data.booking_reservations));
                            }
                            if (data.booking_summary_total !== undefined
                                && data.booking_summary_total !== null
                                && bookingSummaryTotal === undefined
                            ) {
                                bookingSummaryTotal = data.booking_summary_total;
                            }
                            if (data.booking_summary !== undefined && data.booking_summary !== null) {
                                bookingSummary = JSON.parse(data.booking_summary);
                                if (calendar !== undefined && calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                                    getBookingSummaryWeekAndMonth();
                                }
                                if (calendar === undefined || calendar.view.type === 'resourceTimeline') {
                                    getBookingSummaryDay();
                                }
                            }
                            if (data.total_bookings !== undefined && data.total_bookings !== null && data.total_seats !== undefined && data.total_seats !== null) {
                                getBookingSummaryTotal(data.total_bookings, data.total_seats);
                            }
                            if (data.graph !== undefined && data.graph !== null) {
                                dataGraph = data.graph;
                                dataGraph.onlyUpdate = thisIsFirstRunForThisView;
                                tableGraph();
                            }
                        },
                        error: function(xhr, status, error) {
                            console.error('Error fetching events:', error);
                            failureCallback(error);
                        }
                    });
                },
                datesSet: function (dateInfo) {
                    lastTimestamp = null;

                    if(lastViewInfo === null || lastViewInfo.startStr !== dateInfo.startStr || lastViewInfo.endStr !== dateInfo.endStr || lastViewInfo.view.type !== dateInfo.view.type) {
                        lastViewInfo = { startStr: dateInfo.startStr, endStr: dateInfo.endStr, view: dateInfo.view };

                        getOpeningHours(dateInfo.startStr, function (hours) {
                            calendar.setOption('slotMinTime', hours.slotMinTime);
                            calendar.setOption('slotMaxTime', hours.slotMaxTime);
                        });
                        let blockedCells = document.querySelectorAll('.fc-day.blocked, .fc-resource.blocked');
                        blockedCells.forEach(cell => {
                            cell.classList.remove('blocked');
                        });
                        $('.slot-blocked-wrapper').remove();
                        $('.blocking-reservation-day-button').remove();
                        let displayBlock = ($('#blocking-toggle').hasClass('fc-button-active'))?'':'d-none ';
                        if (calendar.view.type === 'resourceTimelineMonth') {
                            $(".fc-timeline-header-row th.fc-timeline-slot").each(function () {
                                $(this).append('<span class="' + displayBlock + 'blocking-btn blocking-reservation-day-button" data-date="' + $(this).attr('data-date') + '"><i class="material-icons">block</i></span>');
                            });
                        }
                        if (calendar.view.type === 'resourceTimeline' || calendar.view.type === 'resourceTimelineWeek') {
                            $(".fc-timeline-header-row th.fc-timeline-slot").each(function () {
                                $(this).append('<span class="' + displayBlock + 'blocking-btn blocking-reservation-day-button blocking-reservation-day-icon-right" data-date="' + $(this).attr('data-date') + '"><i class="material-icons">block</i></span>');
                            });
                        }
                        if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                            let startDate = dateInfo.start;
                            let endDate = dateInfo.end;
                            let endDateTemp = new Date(endDate);
                            endDate.setDate(endDateTemp.getDate() - 1);
                            let currentDate = new Date(startDate);
                            getBookingBlockingList('day', null, null, function (bookingBlockingList) {
                                while (currentDate < endDate) {
                                    let formatedCurrentDate = formatDate(currentDate);
                                    if (bookingBlockingList.includes(formatedCurrentDate)) {
                                        let dayCells = document.querySelectorAll(`.fc-day[data-date="${formatedCurrentDate}"]`);
                                        dayCells.forEach(cell => {
                                            //cell.classList.add('blocked');
                                        });
                                    }
                                    currentDate.setDate(currentDate.getDate() + 1);
                                }
                            });
                            getBookingBlockingList('table', formatDate(startDate), formatDate(endDate), function (bookingBlockingList) {
                                bookingBlockingList.forEach(function (table_id) {
                                    /*let tableCells = document.querySelectorAll(`.fc-resource[data-resource-id="${table_id}"]`);
                                    tableCells.forEach(cell => {
                                        cell.classList.add('blocked');
                                    });*/
                                    $('.fc-datagrid-body.fc-scrollgrid-sync-table td.fc-datagrid-cell.fc-resource[data-resource-id="'+table_id+'"]').addClass('blocked');
                                });
                            });
                        }
                        if (calendar.view.type === 'resourceTimeline') {
                            getBookingBlockingList('table', formatDate(calendar.getDate()), null, function (bookingBlockingList) {
                                bookingBlockingList.forEach(function (table_id) {
                                    let tableCells = document.querySelectorAll(`.fc-resource[data-resource-id="${table_id}"]`);
                                    tableCells.forEach(cell => {
                                        //cell.classList.add('blocked');
                                    });
                                });
                            });
                            /*getBookingBlockingList('slot', formatDate(calendar.getDate()), null, function (bookingBlockingList) {
                                Object.entries(bookingBlockingList).forEach(([tableId, timeslots]) => {
                                    if (tableId === '') {
                                        $(".fc-datagrid-cell.fc-resource").each(function () {
                                            if ($(this).attr('data-resource-id')?.startsWith('booking-area-id')) {
                                                return true;
                                            }
                                            markBlockedTimeslots(timeslots, $(this).attr('data-resource-id'));
                                        });
                                    } else {
                                        markBlockedTimeslots(timeslots, tableId);
                                    }
                                });
                            });*/
                            if (calendarDate !== dateInfo.startStr) {
                                calendarDate = dateInfo.startStr;
                            }
                        }
                    }
                    $("button.fc-today-button").prop("disabled", false);
                },
                eventDrop: function (info) {
                    updateBookingReservation(info.event, info.newResource, function (response) {
                        if (response.error_message !== undefined) {
                            alert(response.error_message);
                            info.revert();
                        }
                    });
                },
                eventResize: function (info) {
                    updateBookingReservation(info.event, null, function (response) {
                        if (response.error_message !== undefined) {
                            alert(response.error_message);
                            info.revert();
                        }
                    });
                },
                eventClick: function (info) {
                    getBookingReservationModal(info, function (modal) {
                        $('#content').append(modal);
                        $('#modal-booking-reservation').modal('show');
                    });
                },
                selectable: true,
                select: function (info) {
                    if (calendar.view.type === 'resourceTimeline') {
                        if (info.resource.extendedProps.notSelectable !== undefined) {
                            return false;
                        }
                        if($('#blocking-toggle').hasClass('fc-button-active')) {
                            getBookingBlockingModal(info.startStr, info.endStr, 'slot',   info.resource.id, function (modal) {
                                $('#content').append(modal);
                                if ($('#modal-booking-blocking').length) {
                                    $('#modal-booking-blocking').modal('show');
                                }
                                if ($('#modal-booking-unblocking').length) {
                                    $('#modal-booking-unblocking').modal('show');
                                }
                            });
                        } else {
                            getBookingReservationModal(info, function (modal) {
                                $('#content').append(modal);
                                if ($('#modal-booking-reservation').length) {
                                    $('#modal-booking-reservation').modal('show');
                                } else if ($('#modal-booking-unblocking').length) {
                                    $('#modal-booking-unblocking').modal('show');
                                }
                            });
                        }
                    }
                    if (calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                        calendarDate = info.startStr;
                        calendar.changeView('resourceTimeline');
                        calendar.gotoDate(info.startStr);
                        getBookingReservationGraph();
                    }
                }
            });
            calendar.setOption('locale', 'NO-nb');
            calendar.setOption('resourceAreaWidth', '15%');
            calendar.render();

            setInterval(function () {
                calendar.refetchEvents();   // uses current view + current lastTimestamp
            }, 60 * 1000);

            let blockingMode = $('#calendar').hasClass('mode-blocking');
            let fullscreenButton = '<button class="fc-button fc-button-primary pb-0" type="button" aria-label="fullscreen" id="calendar-fullscreen"><i class="material-icons p-0" style="color: white;">fullscreen</i></button>';
            let updateButton = '<button class="fc-button fc-button-primary pb-0" type="button" aria-label="update" id="manual-get-booking-data"><i class="material-icons p-0" style="color: white;">update</i></button>';
            let showHideBlockingButtons = blockingMode ? '<button class="fc-button fc-button-primary pb-0 fc-button-active" type="button" aria-label="block" id="blocking-toggle"><i class="material-icons p-0" style="color: white;">block</i></button>' : '';
            $("div.fc-header-toolbar div.fc-toolbar-chunk").last().append(showHideBlockingButtons).append(fullscreenButton).append(updateButton);

            $(document).on("click", "#blocking-toggle", function () {
                if ($(this).hasClass('fc-button-active')) {
                    $(this).removeClass('fc-button-active');
                } else {
                    $(this).addClass('fc-button-active');
                }
                $('.blocking-btn').each(function () {
                    $(this).toggleClass('d-none');
                });
            });

            if(blockingMode) {
                $('.blocking-btn').each(function () {
                    $(this).toggleClass('d-none');
                });
            }

            $(document).on("click", "#calendar-fullscreen", function () {
                let iconContainer = $(".material-icons", this);
                let header = $("header");
                let calendarContainer = $("#calendar").closest(".card-box");
                if ($(this).hasClass('fc-button-active')) {
                    $(this).removeClass('fc-button-active');
                    iconContainer.text('fullscreen');
                    header.removeClass('d-none');
                    calendarContainer.removeClass('fullscreen-calendar-wrapper');
                } else {
                    $(this).addClass('fc-button-active');
                    iconContainer.text('fullscreen_exit');
                    header.addClass('d-none');
                    calendarContainer.addClass('fullscreen-calendar-wrapper');
                }
            });

            let lastUpdateTime = 0;
            function canUpdate() {
                const now = Date.now();
                if (now - lastUpdateTime < 5000) return false;
                lastUpdateTime = now;
                return true;
            }

            $(document).on("click", "#manual-get-booking-data", function () {
                if (!canUpdate()) return;
                /*getBookingReservations(function (events) {
                    calendar.addEventSource(events);
                }, true);*/
                calendar.refetchEvents();
                popupAlert();
            })

            /*function getNewBookingReservations() {
                getBookingReservations(function (events) {
                    calendar.addEventSource(events);
                }, true);
                setTimeout(getNewBookingReservations, 60000);
            }

            setTimeout(getNewBookingReservations, 60000);*/

            $(document).on("click",
                "button.fc-resourceTimelineMonth-button, " +
                "button.fc-resourceTimelineWeek-button, " +
                "button.fc-resourceTimeline-button, " +
                "button.fc-prev-button, " +
                "button.fc-next-button, " +
                "button.fc-today-button", function () {
                    getBookingReservationGraph();
            });

            $(document).on("click", ".blocking-reservation-day-header", function (e) {
                e.preventDefault();
                calendarDate = $(this).closest('th').data('date');
                calendar.changeView('resourceTimeline');
                calendar.gotoDate($(this).closest('th').data('date'));
                getBookingReservationGraph();
            });

            $(document).on("click", ".blocking-reservation-day-button", function () {
                let endDate = null;
                let type = 'day';
                let startDate = $(this).data('date');
                if (calendar.view.type === 'resourceTimeline') {
                    endDate = startDate;
                    type = 'slot';
                }
                getBookingBlockingModal(startDate, endDate, type, null, function (modal) {
                    $('#content').append(modal);
                    if ($('#modal-booking-blocking').length) {
                        $('#modal-booking-blocking').modal('show');
                    }
                    if ($('#modal-booking-unblocking').length) {
                        $('#modal-booking-unblocking').modal('show');
                    }
                });
            });

            $(document).on("click", ".blocking-reservation-table-button", function () {
                let tableId = $(this).attr('data-resource-id');
                let startDate = calendar.view.activeStart;
                let endDate = calendar.view.activeEnd;
                startDate = formatDate(startDate);
                endDate = formatDate(endDate);
                getBookingBlockingModal(startDate, endDate, 'table', tableId, function (modal) {
                    $('#content').append(modal);
                    if ($('#modal-booking-blocking').length) {
                        $('#modal-booking-blocking').modal('show');
                    }
                    if ($('#modal-booking-unblocking').length) {
                        $('#modal-booking-unblocking').modal('show');
                    }
                });
            });

            function tableGraph() {
                if (calendar.view.type === 'resourceTimeline' || calendar.view.type === 'resourceTimelineMonth' || calendar.view.type === 'resourceTimelineWeek') {
                    if (!$('div#booking-bar-graph').length) {
                        $('tr.fc-scrollgrid-section-footer td:last-child div.fc-scrollgrid-sticky-shim').append('<div id="booking-bar-graph"></div>');
                    }
                    $('tr.fc-scrollgrid-section-footer td:last-child div.fc-scrollgrid-sticky-shim').css('height', '190px');
                    $('tr.fc-scrollgrid-section-footer').removeClass('fc-scrollgrid-section-sticky');
                    //$('div#booking-bar-graph').empty();
                    setTimeout(function () {
                        barChart(dataGraph);
                    }, 1500);

                } else {
                    //$('div#booking-bar-graph').remove();
                    $('tr.fc-scrollgrid-section-footer td:last-child div.fc-scrollgrid-sticky-shim').css('height', '1px');
                    if (!$('tr.fc-scrollgrid-section-footer').hasClass('fc-scrollgrid-section-sticky')) {
                        $('tr.fc-scrollgrid-section-footer').addClass('fc-scrollgrid-section-sticky');
                    }
                }
            }

            function getBookingReservationGraph() {
                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_booking_reservation/get_graph",
                    data: {
                        location_id: locationId,
                        calendar_date: calendarDate,
                        period_type: calendar.view.type,
                        active_start: formatDate(calendar.view.activeStart),
                        active_end: formatDate(calendar.view.activeEnd)
                    }
                })
                    .done(function (data) {
                        dataGraph = data.graph;
                        tableGraph();
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    })
            }

            function hashObject(obj) {
                if (typeof obj !== 'object' || obj === null) {
                    throw new TypeError('Input must be a non-null object');
                }

                // Create a sorted and stringified representation of the object
                return Object.keys(obj)
                    .sort()
                    .map(key => {
                        // Handle arrays and other objects recursively
                        const value = Array.isArray(obj[key]) ? JSON.stringify(obj[key]) : obj[key];
                        return `${key}:${value}`;
                    })
                    .join('|');
            }

            let barChartDate = null;
            let lastPrimalData = null;
            let lastPrimalDataHash = null;
            let chart;

            function barChart(primalData) {
                let hashOfCurrentPrimalData = hashObject(primalData);
                if(lastPrimalData === null || chart === undefined) {
                    if (barChartDate !== calendarDate){
                        barChartDate = calendarDate;
                        //$('#booking-bar-graph').empty();
                    }

                    let width = parseInt($('tr.fc-scrollgrid-section-footer td:last-child div.fc-scrollgrid-sticky-shim').css('width'), 10);
                    let minWidth = parseInt($('tr.fc-scrollgrid-section-footer td:last-child div.fc-scrollgrid-sticky-shim').css('min-width'), 10);
                    if (minWidth > width) {
                        width = minWidth;
                    }

                    let open = calendar.getOption('slotMinTime');
                    let close = calendar.getOption('slotMaxTime');
                    let start = new Date(`1970-01-01T${open}`);
                    let end = new Date(`1970-01-01T${close}`);
                    let timeDifference = (end - start) / 60000;
                    let numberOfTimeSlots = Math.ceil(timeDifference / 15);
                    let remainingTimeSlotsToFullHour = numberOfTimeSlots % 4;
                    if (remainingTimeSlotsToFullHour > 0) {
                        let extraTimeSlots = 4 - remainingTimeSlotsToFullHour
                        if (extraTimeSlots > 0) {
                            let slotWidth = 30;
                            if ($("div.fc-timeline-slots td.fc-timeline-slot.fc-timeline-slot-lane").first().length) {
                                slotWidth = $("div.fc-timeline-slots td.fc-timeline-slot.fc-timeline-slot-lane").first().outerWidth();
                            }
                            width = width + (extraTimeSlots * slotWidth);
                        }
                    }

                    chart = Highcharts.chart('booking-bar-graph', {
                        chart: {
                            type: 'line',
                            height: 200,
                            width: width
                        },
                        exporting: {enabled: false},
                        title: false,
                        xAxis: {
                            categories: primalData.hour,
                            title: {
                                enabled: false
                            }
                        },
                        yAxis: {
                            labels: {
                                enabled: false
                            },
                            title: {
                                enabled: false
                            }
                        },
                        plotOptions: {
                            series: {
                                animation: false
                            }
                        },
                        credits: {enabled: false},
                        series: [{
                            showInLegend: false,
                            data: primalData.number_of_bookings,
                            name: 'Antall bookinger'
                        },
                            {
                                showInLegend: false,
                                data: primalData.number_of_seats,
                                name: 'Antall seter'
                            }]
                    });
                } else if(lastPrimalDataHash !== hashOfCurrentPrimalData) {
                    chart.series[0].setData(primalData.number_of_bookings, false);
                    chart.series[1].setData(primalData.number_of_seats, false);
                    chart.redraw();
                }

                if(lastPrimalData === null){
                    lastPrimalData = primalData;
                    lastPrimalDataHash = hashOfCurrentPrimalData;
                } else if(lastPrimalDataHash !== hashOfCurrentPrimalData){
                    lastPrimalData = primalData;
                    lastPrimalDataHash = hashOfCurrentPrimalData;
                }
            }

            let bookingReservationHasArrivedAjaxLock = false;
            $(document).on("click", "#booking-reservation-has-arrived-btn", function () {
                let thisButton = $(this);
                if (!bookingReservationHasArrivedAjaxLock) {
                    bookingReservationHasArrivedAjaxLock = true;
                    $.ajax({
                        type: 'POST',
                        url: "/ajax/organizer_booking_reservation/has_arrived",
                        data: {
                            booking_reservation_id: $('input[name="booking_reservation_id"]', thisButton.closest('#booking-reservation-from-admin-form')).val()
                        }
                    })
                        .done(function (data) {
                            bookingReservationHasArrivedAjaxLock = false;
                            if (data.html !== undefined && data.html !== null) {
                                thisButton.replaceWith(data.html);
                            }
                        })
                        .fail(function (data) {
                            bookingReservationHasArrivedAjaxLock = false;
                            if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                                document.location.href = data.responseJSON.redirect_url;
                            }
                            if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                                prependAlert('#booking-reservation-form-button-wrapper', data.responseJSON.error_message, 'danger', null, '#booking-reservation-from-admin-form');
                            }
                        })
                }
            });
        }

    }
);
